export function installPrimevueDropdownNoJump() {
  if (typeof window === 'undefined') return;
  if (window.__primevueDropdownNoJumpInstalled) return;

  window.__primevueDropdownNoJumpInstalled = true;

  const originalScrollIntoView = Element.prototype.scrollIntoView;
  const originalFocus = HTMLElement.prototype.focus;

  let lockUntil = 0;
  let last = null;

  const getScroller = () => document.querySelector('#edit_content');

  const isDropdownRelated = (el) => {
    return el?.closest?.(
      '#edit_content .p-dropdown, .p-dropdown-panel, .p-dropdown-item, .p-dropdown-filter'
    );
  };

  const restoreScroll = () => {
    const scroller = getScroller();
    if (!scroller || !last) return;

    scroller.scrollTop = last.editorTop;
    scroller.scrollLeft = last.editorLeft;
    window.scrollTo(last.winX, last.winY);
  };

  const rememberScroll = (event) => {
    const dropdown = event.target.closest?.('#edit_content .p-dropdown');
    const scroller = getScroller();

    if (!dropdown || !scroller) return;

    lockUntil = Date.now() + 500;
    last = {
      editorTop: scroller.scrollTop,
      editorLeft: scroller.scrollLeft,
      winX: window.scrollX,
      winY: window.scrollY,
    };

    requestAnimationFrame(restoreScroll);
    setTimeout(restoreScroll, 0);
    setTimeout(restoreScroll, 50);
    setTimeout(restoreScroll, 150);
    setTimeout(restoreScroll, 300);
  };

  Element.prototype.scrollIntoView = function (...args) {
    if (Date.now() < lockUntil && isDropdownRelated(this)) return;
    return originalScrollIntoView.apply(this, args);
  };

  HTMLElement.prototype.focus = function (...args) {
    if (Date.now() < lockUntil && isDropdownRelated(this)) {
      return originalFocus.call(this, { preventScroll: true });
    }

    return originalFocus.apply(this, args);
  };

  ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach((type) => {
    document.addEventListener(type, rememberScroll, true);
  });
}
